import { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useOffer } from '../offers/OfferContext.jsx';

export function TeamBlock({ t }) {
  return (
    <section className="ssi-team" style={teamStyles.wrap}>
      <div className="ssi-team__cols" style={teamStyles.cols}>
        <div className="ssi-team__copy" style={teamStyles.copy}>
          <div className="ssi-team__head">
            <div style={teamStyles.kicker}>{t.teamKicker}</div>
            <h2 style={teamStyles.h2}>{t.teamTitle}</h2>
          </div>
          <div className="ssi-team__body">
            <p style={teamStyles.p}>{t.teamP1}</p>
            <p style={teamStyles.p}>{t.teamP2}</p>
            {t.teamP3 && <p style={teamStyles.p}>{t.teamP3}</p>}
            {t.teamP4 && <p style={teamStyles.p}>{t.teamP4}</p>}
            {t.teamP5 && <p style={teamStyles.p}>{t.teamP5}</p>}
            <Link to="/about" className="btn btn--ghost">{t.teamCta}</Link>
          </div>
        </div>
        <div className="ssi-team__portrait" style={teamStyles.portrait}>
          <img src="/assets/aran-catrin-update.jpeg" alt="" style={teamStyles.img}/>
        </div>
      </div>
    </section>
  );
}

export function Gift({ t }) {
  return (
    <section className="ssi-gift" style={giftStyles.wrap}>
      <div className="ssi-gift__card" style={giftStyles.card}>
        <div style={giftStyles.ribbon}>Gift</div>
        <div className="ssi-gift__copy" style={giftStyles.copy}>
          <div style={{...giftStyles.kicker,color:'var(--gold)'}}>{t.giftKicker}</div>
          <h2 style={giftStyles.h2}>{t.giftTitle}</h2>
          <p style={giftStyles.p}>{t.giftBody}</p>
          <Link to="/gift" className="btn btn--onDark">{t.giftCta}</Link>
        </div>
        <div className="ssi-gift__right" style={giftStyles.right}>
          <img src="/assets/hero_man_waving.png" alt="" style={giftStyles.img}/>
        </div>
      </div>
    </section>
  );
}

export function News({ t }) {
  const posts = [
    { tag:t.newsTag1, title:t.newsTitle1, img:'hero_woman_pointing.png' },
    { tag:t.newsTag2, title:t.newsTitle2, img:'hero_woman_hijab.png' },
    { tag:t.newsTag3, title:t.newsTitle3, img:'hero_couple_laughing.png' },
  ];
  return (
    <section className="ssi-news" style={newsStyles.wrap}>
      <div style={newsStyles.head}>
        <h2 style={newsStyles.h2}>{t.newsTitle}</h2>
        <a href="#" style={newsStyles.link}>{t.newsViewAll}</a>
      </div>
      <div className="ssi-news__grid" style={newsStyles.grid}>
        {posts.map(p => (
          <article key={p.title} style={newsStyles.card}>
            <img src={`/assets/${p.img}`} alt="" style={newsStyles.img}/>
            <div style={newsStyles.body}>
              <div style={newsStyles.tag}>{p.tag}</div>
              <h3 style={newsStyles.ch}>{p.title}</h3>
              <a href="#" style={newsStyles.readMore}>{t.newsReadMore}</a>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}

/* Social icons row — Facebook, Instagram, LinkedIn, YouTube, SoundCloud. */
const SOCIALS = [
  { key: 'facebook',   label: 'Facebook',   href: 'https://www.facebook.com/SaySomethinginWelsh',         vb: '0 0 12 22',  path: 'M11.2136 12.375L11.8359 8.39352H7.94515V5.8098C7.94515 4.72055 8.48866 3.65879 10.2312 3.65879H12V0.268984C12 0.268984 10.3949 0 8.86019 0C5.65604 0 3.56167 1.90695 3.56167 5.35906V8.39352H0V12.375H3.56167V22H7.94515V12.375H11.2136Z' },
  { key: 'instagram',  label: 'Instagram',  href: 'https://www.instagram.com/saysomethinginwelsh/',       vb: '0 0 24 24', path: 'M12.0027 5.8467C8.59743 5.8467 5.85075 8.594 5.85075 12C5.85075 15.406 8.59743 18.1533 12.0027 18.1533C15.4079 18.1533 18.1546 15.406 18.1546 12C18.1546 8.594 15.4079 5.8467 12.0027 5.8467ZM12.0027 16.0004C9.80212 16.0004 8.00312 14.2064 8.00312 12C8.00312 9.7936 9.79677 7.99955 12.0027 7.99955C14.2086 7.99955 16.0022 9.7936 16.0022 12C16.0022 14.2064 14.2032 16.0004 12.0027 16.0004ZM19.8412 5.595C19.8412 6.39295 19.1987 7.03024 18.4062 7.03024C17.6085 7.03024 16.9713 6.38759 16.9713 5.595C16.9713 4.80241 17.6138 4.15977 18.4062 4.15977C19.1987 4.15977 19.8412 4.80241 19.8412 5.595ZM23.9157 7.05166C23.8247 5.12909 23.3856 3.42608 21.9775 2.02298C20.5747 0.619882 18.8721 0.180743 16.9499 0.0843468C14.9689 -0.0281156 9.03112 -0.0281156 7.05008 0.0843468C5.1333 0.175388 3.43068 0.614526 2.02253 2.01763C0.614389 3.42073 0.180703 5.12373 0.0843279 7.0463C-0.0281093 9.02778 -0.0281093 14.9669 0.0843279 16.9483C0.175349 18.8709 0.614389 20.5739 2.02253 21.977C3.43068 23.3801 5.12794 23.8193 7.05008 23.9157C9.03112 24.0281 14.9689 24.0281 16.9499 23.9157C18.8721 23.8246 20.5747 23.3855 21.9775 21.977C23.3803 20.5739 23.8193 18.8709 23.9157 16.9483C24.0281 14.9669 24.0281 9.03314 23.9157 7.05166ZM21.3564 19.0744C20.9388 20.1241 20.1303 20.9327 19.0755 21.3558C17.496 21.9824 13.7481 21.8378 12.0027 21.8378C10.2572 21.8378 6.50396 21.977 4.92984 21.3558C3.88042 20.9381 3.07195 20.1294 2.64897 19.0744C2.02253 17.4946 2.16709 13.7458 2.16709 12C2.16709 10.2542 2.02789 6.50006 2.64897 4.92558C3.06659 3.87593 3.87507 3.06728 4.92984 2.6442C6.50931 2.01763 10.2572 2.16222 12.0027 2.16222C13.7481 2.16222 17.5014 2.02298 19.0755 2.6442C20.1249 3.06192 20.9334 3.87058 21.3564 4.92558C21.9828 6.50541 21.8383 10.2542 21.8383 12C21.8383 13.7458 21.9828 17.4999 21.3564 19.0744Z' },
  { key: 'linkedin',   label: 'LinkedIn',   href: 'https://www.linkedin.com/company/saysomethingin-com-cyf', vb: '0 0 24 24', path: 'M5.37214 24H0.396429V7.97643H5.37214V24ZM2.88161 5.79066C1.29054 5.79066 0 4.47278 0 2.88167C1.13882e-08 2.1174 0.303597 1.38444 0.844003 0.844022C1.38441 0.303604 2.11736 0 2.88161 0C3.64586 0 4.3788 0.303604 4.91921 0.844022C5.45962 1.38444 5.76321 2.1174 5.76321 2.88167C5.76321 4.47278 4.47214 5.79066 2.88161 5.79066ZM23.9946 24H19.0296V16.1998C19.0296 14.3409 18.9921 11.9569 16.4427 11.9569C13.8557 11.9569 13.4593 13.9766 13.4593 16.0659V24H8.48893V7.97643H13.2611V10.1622H13.3307C13.995 8.90323 15.6177 7.57463 18.0386 7.57463C23.0743 7.57463 24 10.8908 24 15.198V24H23.9946Z' },
  { key: 'youtube',    label: 'YouTube',    href: 'https://www.youtube.com/c/SaySomethinginLanguages',    vb: '0 0 34 23',  path: 'M33.2995 3.59895C32.9077 2.19165 31.7593 1.08229 30.3029 0.703349C27.6423 0 16.9996 0 16.9996 0C16.9996 0 6.35737 0 3.69676 0.676683C2.2684 1.05522 1.09197 2.19185 0.700172 3.59895C0 6.16934 0 11.5 0 11.5C0 11.5 0 16.8575 0.700172 19.401C1.09238 20.8081 2.24039 21.9175 3.69697 22.2964C6.38539 23 17 23 17 23C17 23 27.6423 23 30.3029 22.3233C31.7595 21.9446 32.9077 20.8352 33.2999 19.4281C33.9999 16.8575 33.9999 11.5271 33.9999 11.5271C33.9999 11.5271 34.0279 6.16934 33.2995 3.59895ZM13.6112 16.4246V6.57535L22.4611 11.5L13.6112 16.4246Z' },
  { key: 'soundcloud', label: 'SoundCloud', href: 'https://soundcloud.com/user-546696035',                vb: '0 0 30 24',  path: 'M25.89 10.35c-.34 0-.68.04-1 .11-.43-4.35-4.11-7.75-8.57-7.75-.53 0-.96.43-.96.96v15.3c0 .53.43.96.96.96h9.56c2.64 0 4.78-2.14 4.78-4.78s-2.14-4.78-4.78-4.78zm-13.39-5.74c-.53 0-.96.43-.96.96v13.39c0 .53.43.96.96.96s.96-.43.96-.96v-13.39c0-.53-.43-.96-.96-.96zm-3.82 3.83c-.53 0-.96.43-.96.96v9.56c0 .53.43.96.96.96s.96-.43.96-.96v-9.56c0-.53-.43-.96-.96-.96zm-3.83 0c-.53 0-.96.43-.96.96v9.56c0 .53.43.96.96.96s.96-.43.96-.96v-9.56c0-.53-.43-.96-.96-.96zm-3.82 2.87c-.53 0-.96.43-.96.96v5.74c0 .53.43.96.96.96s.96-.43.96-.96v-5.74c0-.53-.43-.96-.96-.96z' },
];

function SocialLinks() {
  return (
    <div className="ssi-footer__socials">
      <div className="ssi-footer__socialsHead" style={footerStyles.socialsHead}>Follow us on</div>
      <div className="ssi-footer__socialsRow" style={footerStyles.socialsRow} role="navigation" aria-label="Social media links">
        {SOCIALS.map(s => (
          <a
            key={s.key}
            href={s.href}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={s.label}
            className={`ssi-footer__social ssi-footer__social--${s.key}`}
            style={footerStyles.socialLink}
          >
            <svg viewBox={s.vb} width="18" height="18" aria-hidden="true" focusable="false">
              <path d={s.path} fill="currentColor"/>
            </svg>
          </a>
        ))}
      </div>
    </div>
  );
}

function TrustpilotWidget({ theme = 'light', height = '20px' }) {
  const ref = useRef(null);
  useEffect(() => {
    const SRC = 'https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';
    function hydrate() {
      if (window.Trustpilot && ref.current) {
        window.Trustpilot.loadFromElement(ref.current, true);
      }
    }
    if (!document.querySelector('script[src="' + SRC + '"]')) {
      const s = document.createElement('script');
      s.src = SRC; s.async = true;
      s.onload = hydrate;
      document.head.appendChild(s);
    } else {
      hydrate();
    }
  }, []);
  return (
    <div
      ref={ref}
      className="trustpilot-widget ssi-footer__trustpilot"
      data-locale="en-GB"
      data-template-id="5419b6a8b0d04a076446a9ad"
      data-businessunit-id="62b1a217df4a9d85d4fd3340"
      data-style-height={height}
      data-style-width="240px"
      style={{ width: 240, alignSelf: 'flex-start', marginLeft: -8 }}
      data-theme={theme}
      data-min-review-count="10"
    >
      <a href="https://uk.trustpilot.com/review/saysomethingin.com" target="_blank" rel="noopener">Trustpilot</a>
    </div>
  );
}

export function Footer({ t, hideCta, defaultBilling = 'annual' }) {
  const [billing, setBilling] = useState(defaultBilling);
  // Offer test (Design handoff 2026-06-11): when a variant is active the
  // brand-red CTA block pitches that variant's offer instead of the 7-day
  // trial. Footer renders on every page, so this keeps the pitch consistent
  // even on pages outside the four-funnel set (about, community, …).
  const offer = useOffer();
  const ofc = offer ? offer.config.footerCta : null;
  return (
    <footer>
      <style>{`
        .ssi-footer__social { transition: background .16s ease, color .16s ease, transform .16s ease; }
        .ssi-footer__social:hover { background: var(--brandRed) !important; color: #fff !important; transform: translateY(-2px); }
      `}</style>
      {!hideCta && ofc && (<div className="ssi-footer__topBlock" style={footerStyles.topBlock}>
        <div className="ssi-footer__cta" style={footerStyles.cta}>
        <h2 style={footerStyles.h2}>{t.footerCta}</h2>

        <div style={footerStyles.price}>
          {ofc.curr ? <span style={footerStyles.priceCurr}>{ofc.curr}</span> : null}
          <span style={footerStyles.priceNum}>{ofc.num}</span>
          <span style={footerStyles.pricePer}>{ofc.per}</span>
        </div>

        <Link to="/pay" style={footerStyles.ctaBtn}>
          {ofc.cta}
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" style={{marginLeft:8}}>
            <path d="M2 7h10m0 0L8 3m4 4L8 11" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </Link>

        <div style={footerStyles.trialNote}>{ofc.note}</div>
        </div>
      </div>)}
      {!hideCta && !ofc && (<div className="ssi-footer__topBlock" style={footerStyles.topBlock}>
        <div className="ssi-footer__cta" style={footerStyles.cta}>
        <h2 style={footerStyles.h2}>{t.footerCta}</h2>

        <div style={footerStyles.billingToggle} role="tablist" aria-label="Billing period">
          {['monthly','annual'].map(p => {
            const active = billing === p;
            return (
              <button
                key={p}
                role="tab"
                type="button"
                aria-selected={active}
                onClick={() => setBilling(p)}
                style={{
                  ...footerStyles.billingBtn,
                  background: active ? '#fff' : 'transparent',
                  color: active ? 'var(--brandRed)' : 'rgba(255,255,255,.78)',
                  boxShadow: active ? '0 1px 2px rgba(0,0,0,.15), 0 4px 10px rgba(0,0,0,.12)' : 'none',
                  fontWeight: active ? 600 : 500,
                }}>
                {p === 'monthly' ? 'Monthly' : 'Annual'}
                {p === 'annual' && <span style={footerStyles.savingPill}>Save £30</span>}
              </button>
            );
          })}
        </div>

        <div style={footerStyles.price}>
          <span style={footerStyles.priceCurr}>£</span>
          <span style={footerStyles.priceNum}>{billing === 'annual' ? '150' : '15'}</span>
          <span style={footerStyles.pricePer}>{billing === 'annual' ? '/year' : '/month'}</span>
        </div>

        <Link to={`/pay?plan=${billing}`} style={footerStyles.ctaBtn}>
          Start your 7 days free
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" style={{marginLeft:8}}>
            <path d="M2 7h10m0 0L8 3m4 4L8 11" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </Link>

        <div style={footerStyles.trialNote}>
          <strong style={{color:'#fff'}}>7 days free</strong> to make sure you&rsquo;re loving it. No card charged until day 8.
        </div>
        </div>
      </div>)}
      <div className="ssi-footer__bottomBlock" style={footerStyles.bottomBlock}>
        <div className="ssi-footer__bottom" style={footerStyles.bottom}>
          <div className="ssi-footer__brandCol" style={footerStyles.brandCol}>
            <Link to="/"><img src="/assets/logo.svg?v=2" alt="SaySomethingin" style={{height:32, display:'block'}}/></Link>
            <TrustpilotWidget theme="light" height="24px"/>
            <SocialLinks/>
          </div>
          <div className="ssi-footer__cols" style={footerStyles.cols}>
            <div>
              <div style={footerStyles.head4}>{t.footerCol1}</div>
              {[
                ['Mission','/mission'],
                ['Intensive Learning','/intensive-learning-hub'],
                ['Our team','/about'],
                ['Contact','/contact'],
              ].map(([l,h]) =>
                <Link key={l} to={h} style={footerStyles.fl}>{l}</Link>)}
            </div>
            <div>
              <div style={footerStyles.head4}>{t.footerCol2}</div>
              {[
                ['Forum','/forum'],
                ['Community','/community'],
                ['Celebrity videos','/celebrity-coaching'],
                ['Learner Stories','/testimonials'],
              ].map(([l,h]) =>
                <Link key={l} to={h} style={footerStyles.fl}>{l}</Link>)}
            </div>
          </div>
        </div>
        <div className="ssi-footer__legal" style={footerStyles.legal}>
          <span>{t.footerLegal}</span>
          <span style={footerStyles.legalLinks}>
            <Link to="/privacy" style={footerStyles.legalLink}>Privacy</Link>
            <span style={footerStyles.legalSep}>·</span>
            <Link to="/terms" style={footerStyles.legalLink}>Terms</Link>
            <span style={footerStyles.legalSep}>·</span>
            <Link to="/refunds" style={footerStyles.legalLink}>Refunds</Link>
          </span>
        </div>
      </div>
    </footer>
  );
}

const teamStyles = {
  wrap: { padding:'56px 32px 96px', maxWidth:1440, margin:'0 auto' },
  cols: { display:'grid', gridTemplateColumns:'1.1fr 1fr', gap:64, alignItems:'start' },
  copy: {},
  kicker: { fontSize:12, letterSpacing:'.14em', textTransform:'uppercase', color:'var(--brandRed)', fontWeight:600, marginBottom:12 },
  h2: { fontFamily:'var(--font-display)', fontSize:44, lineHeight:1.1, margin:'0 0 20px', letterSpacing:'-.01em' },
  p: { fontSize:16, color:'var(--grey)', lineHeight:1.6, marginBottom:16, maxWidth:520 },
  portrait: { borderRadius:20, overflow:'hidden', aspectRatio:'4/5' },
  img: { width:'100%', height:'100%', objectFit:'cover' },
};
const giftStyles = {
  wrap: { padding:'40px 32px 80px', maxWidth:1440, margin:'0 auto' },
  card: {
    position:'relative',
    background:
      "url(\"data:image/svg+xml;utf8," +
      encodeURIComponent(
        `<svg xmlns='http://www.w3.org/2000/svg' width='280' height='280' viewBox='0 0 280 280'>
          <g fill='%23FEC902'>
            <path d='M40 30 L43 40 L53 43 L43 46 L40 56 L37 46 L27 43 L37 40 Z' opacity='.55'/>
            <path d='M210 60 L214 74 L228 78 L214 82 L210 96 L206 82 L192 78 L206 74 Z' opacity='.45'/>
            <path d='M120 120 L122 126 L128 128 L122 130 L120 136 L118 130 L112 128 L118 126 Z' opacity='.7'/>
            <path d='M250 200 L253 210 L263 213 L253 216 L250 226 L247 216 L237 213 L247 210 Z' opacity='.5'/>
            <path d='M70 220 L73 230 L83 233 L73 236 L70 246 L67 236 L57 233 L67 230 Z' opacity='.4'/>
            <circle cx='170' cy='180' r='2.5' opacity='.6'/>
            <circle cx='90' cy='90' r='1.8' opacity='.5'/>
            <circle cx='240' cy='120' r='1.5' opacity='.45'/>
            <circle cx='30' cy='160' r='2' opacity='.55'/>
            <circle cx='180' cy='260' r='1.8' opacity='.4'/>
          </g>
          <g fill='%23F2D7D7'>
            <circle cx='200' cy='30' r='1.2' opacity='.5'/>
            <circle cx='60' cy='260' r='1.2' opacity='.45'/>
            <circle cx='260' cy='260' r='1.2' opacity='.4'/>
          </g>
        </svg>`
      ) + "\")," +
      "radial-gradient(120% 90% at 20% 20%, #E8392B 0%, #C2130C 45%, #8E0A06 100%)",
    backgroundSize: '280px 280px, cover',
    backgroundRepeat: 'repeat, no-repeat',
    color:'#fff', borderRadius:24, overflow:'hidden',
    display:'grid', gridTemplateColumns:'1.2fr 1fr', alignItems:'stretch',
    boxShadow: '0 24px 60px -20px rgba(73,3,0,.55)',
  },
  copy: { padding:'64px 56px', position:'relative', zIndex:1 },
  kicker: { fontSize:12, letterSpacing:'.14em', textTransform:'uppercase', fontWeight:600, marginBottom:12 },
  h2: { fontFamily:'var(--font-display)', fontSize:44, lineHeight:1.1, margin:'0 0 18px', color:'#fff', letterSpacing:'-.01em' },
  p: { fontSize:16, lineHeight:1.6, color:'rgba(255,255,255,.9)', marginBottom:28, maxWidth:520 },
  right: { position:'relative' },
  img: { width:'100%', height:'100%', objectFit:'cover', display:'block' },
  ribbon: {
    position:'absolute', top: 38, right: -70, width: 260,
    transform:'rotate(45deg)', transformOrigin:'center',
    background:'linear-gradient(180deg, #FEE063 0%, #FEC902 55%, #D9A700 100%)',
    color:'#3a2900', fontFamily:'var(--font-display)', fontSize:13, fontWeight:700,
    letterSpacing:'.18em', textTransform:'uppercase',
    textAlign:'center', padding:'9px 0',
    boxShadow:'0 6px 16px -6px rgba(0,0,0,.45), inset 0 1px 0 rgba(255,255,255,.4)',
    zIndex:2,
  },
};
const newsStyles = {
  wrap: { padding:'0 32px 96px', maxWidth:1440, margin:'0 auto' },
  head: { display:'flex', alignItems:'baseline', justifyContent:'space-between', marginBottom:32 },
  h2: { fontFamily:'var(--font-display)', fontSize:36, margin:0, letterSpacing:'-.01em' },
  link: { fontSize:14, color:'var(--brandRed)', fontWeight:500 },
  grid: { display:'grid', gridTemplateColumns:'repeat(3,1fr)', gap:20 },
  card: { background:'#fff', border:'1px solid var(--border)', borderRadius:20, overflow:'hidden', boxShadow:'var(--shadow-sm)' },
  img: { width:'100%', height:220, objectFit:'cover', display:'block' },
  body: { padding:'22px 24px 26px' },
  tag: { fontSize:11, letterSpacing:'.12em', textTransform:'uppercase', color:'var(--brandRed)', fontWeight:600, marginBottom:8 },
  ch: { fontFamily:'var(--font-display)', fontSize:22, margin:'0 0 14px', lineHeight:1.2 },
  readMore: { fontSize:13, color:'var(--fg-1)', fontWeight:500 },
};
const footerStyles = {
  topBlock: { background:'var(--brandRed)', color:'#fff' },
  bottomBlock: { background:'#fff', color:'var(--darkGrey)' },
  cta: { textAlign:'center', padding:'96px 32px 80px', maxWidth:520, margin:'0 auto' },
  h2: { fontFamily:'var(--font-display)', fontSize:44, lineHeight:1.1, color:'#fff', margin:'0 0 32px', letterSpacing:'-.01em' },

  billingToggle: { display:'inline-flex', padding:4, background:'rgba(0,0,0,.18)', borderRadius:999, marginBottom:24, gap:2 },
  billingBtn: {
    position:'relative', border:0, padding:'8px 16px', borderRadius:999, cursor:'pointer',
    fontSize:13, fontFamily:'inherit', letterSpacing:'-.005em',
    transition:'background 160ms ease, color 160ms ease, box-shadow 160ms ease',
    display:'inline-flex', alignItems:'center', gap:8,
  },
  savingPill: {
    fontSize:10, fontWeight:600, letterSpacing:'.04em',
    background:'var(--brandRed)', color:'#fff',
    padding:'2px 7px', borderRadius:999, textTransform:'uppercase',
  },
  price: { display:'flex', alignItems:'baseline', justifyContent:'center', gap:2, color:'#fff', marginBottom:24 },
  priceCurr: { fontFamily:'var(--font-display)', fontSize:28, fontWeight:500, color:'rgba(255,255,255,.85)' },
  priceNum: { fontFamily:'var(--font-display)', fontSize:72, lineHeight:1, letterSpacing:'-.02em', fontWeight:500, color:'#fff' },
  pricePer: { fontSize:16, color:'rgba(255,255,255,.78)', marginLeft:4 },
  ctaBtn: {
    display:'inline-flex', alignItems:'center', justifyContent:'center',
    background:'#fff', color:'var(--brandRed)',
    padding:'16px 28px', borderRadius:12,
    fontSize:15.5, fontWeight:600, textDecoration:'none',
    boxShadow:'0 6px 16px -6px rgba(0,0,0,.35)',
  },
  trialNote: { fontSize:13.5, color:'rgba(255,255,255,.82)', marginTop:18, lineHeight:1.5 },

  bottom: { padding:'48px 32px 32px', maxWidth:1440, margin:'0 auto', display:'grid', gridTemplateColumns:'minmax(260px, 300px) 1fr', gap:48, alignItems:'start' },
  brandCol: { display:'flex', flexDirection:'column', gap:18, alignItems:'flex-start', width:'100%', minWidth:0 },
  socialsHead: { fontSize:13, letterSpacing:'.08em', textTransform:'uppercase', color:'var(--grey)', fontWeight:600, marginBottom:10 },
  socialsRow: { display:'flex', gap:8, flexWrap:'wrap' },
  socialLink: {
    display:'inline-flex', alignItems:'center', justifyContent:'center',
    width:36, height:36, borderRadius:999,
    background:'var(--offWhite, #f6f4ef)',
    color:'var(--fg-1)',
    textDecoration:'none',
    transition:'background 160ms ease, color 160ms ease, transform 160ms ease',
  },
  cols: { display:'grid', gridTemplateColumns:'repeat(2,1fr)', gap:48 },
  head4: { fontFamily:'var(--font-display)', fontSize:16, marginBottom:12, color:'var(--darkGrey)', fontWeight:600 },
  fl: { display:'block', color:'var(--grey)', textDecoration:'none', fontSize:14, padding:'4px 0' },
  legal: { borderTop:'1px solid var(--border)', padding:'22px 32px', fontSize:12, color:'var(--grey)', maxWidth:1440, margin:'0 auto', display:'flex', justifyContent:'space-between', alignItems:'center', gap:16, flexWrap:'wrap' },
  legalLinks: { display:'inline-flex', gap:10, alignItems:'baseline' },
  legalLink: { color:'var(--grey)', textDecoration:'none' },
  legalSep: { color:'var(--border)' },
};
